import '../../../../styles/Message/Message.css';
import StandDocumentMediaModel   from 'models/StandDocumentMediaModel';
import { Button }                from 'antd';
import { Col }                   from 'antd';
import Row                       from 'components/App/Row';
import { observer }              from 'mobx-react';
import { DownloadOutlined }      from '@ant-design/icons';
import FormattedMessageWrapper   from 'components/App/FormattedMessageWrapper';
import { appStore }              from 'stores/AppStore';
import currentSession            from 'utils/currentSession';
import { ROLES_CONVERTER }       from 'utils/constants';
import { toSafeMessageHtml }     from 'utils/richTextContent';
import { ApiCollection }         from 'collections/ApiCollection';
import StandDocumentMessageModel from 'models/StandDocumentMessageModel';

interface StandDocumentMediasProps {
  standDocumentMediaCollection: ApiCollection<StandDocumentMediaModel>;
  standDocumentMessage: StandDocumentMessageModel;
}

const StandDocumentMedias = observer(({
  standDocumentMediaCollection,
  standDocumentMessage,
}: StandDocumentMediasProps) => (
  <ul>
    {standDocumentMediaCollection
      .filter(standDocumentMedia => standDocumentMedia.messageId === standDocumentMessage.id)
      .map(standDocumentMedia => (
        <li key={standDocumentMedia.id}>
          <a href={standDocumentMedia.objectUrl} rel="noreferrer" target="_blank">
            <DownloadOutlined /> <FormattedMessageWrapper id="Télécharger" /> {standDocumentMedia.mediaFileName}
          </a>
        </li>
      ))}
  </ul>
));

interface StandDocumentMessageProps {
  editMessage?: (() => void) | null;
  lastMessage: boolean;
  standDocumentMediaCollection: ApiCollection<StandDocumentMediaModel>;
  standDocumentMessage: StandDocumentMessageModel;
}

const StandDocumentMessage = ({
  editMessage,
  lastMessage,
  standDocumentMediaCollection,
  standDocumentMessage,
}: StandDocumentMessageProps) => {
  const { roleCollection } = appStore;

  const messageContent = standDocumentMessage.content ? standDocumentMessage.content : '';

  const transformRole = (role: string) => {
    let found = null;

    if (roleCollection.models) {
      found = roleCollection.models.find(roleModel => roleModel.get('@id') === role);

      if (found) {
        return <FormattedMessageWrapper id={found.get('label').replace('Super ', '')} />;
      }
    }

    return null;
  };

  return (
    <Row
      className={`message ${
        currentSession.user.user_id === standDocumentMessage.createdById ? 'me' : 'not-me'
      }`}
      style={{ width: '100%' }}
    >
      <Col className="message-header" span={6}>
        <div className="main">
          <small>{standDocumentMessage.createdAtDate.format('DD/MM/YYYY HH:mm')}</small>

          {lastMessage ? (
            <>
              <br />
              <b>
                <FormattedMessageWrapper id="Organisateur" />
              </b>
            </>
          ) : (
            <>
              {standDocumentMessage.createdByFirstName && (
                <>
                  <br />
                  <b>{standDocumentMessage.createdByFullName}</b>
                </>
              )}

              <br />

              {standDocumentMessage.createdByStandRole
                ? ROLES_CONVERTER[standDocumentMessage.createdByStandRole]
                : transformRole(standDocumentMessage.createdByRoleIri)}
            </>
          )}
        </div>
      </Col>

      <Col className="message-body" span={18}>
        <div className="message-text">
          <div style={{ float: 'right', marginBottom: 10, marginLeft: 10 }}>
            {editMessage && (
              <Button htmlType="button" onClick={editMessage}>
                <FormattedMessageWrapper id="Modifier" />
              </Button>
            )}
          </div>

          <div dangerouslySetInnerHTML={{ __html: toSafeMessageHtml(messageContent) }} />
        </div>

        <div className="message-attachments">
          <StandDocumentMedias
            standDocumentMediaCollection={standDocumentMediaCollection}
            standDocumentMessage={standDocumentMessage}
          />
        </div>
      </Col>
    </Row>
  );
};

const StandDocumentMessageObserver = observer(StandDocumentMessage);

export default StandDocumentMessageObserver;
